/* curlpro-cart.js: AJAX add to cart wired to the theme's cart drawer, with /cart fallback */
window.CurlproCart = window.CurlproCart || {
  async add(items, opts) {
    opts = opts || {};
    const drawer = document.querySelector('cart-drawer');
    const body = { items: items.map(i => ({ id: Number(i.id), quantity: Number(i.quantity) || 1 })) };
    const useDrawer = !opts.buyNow && drawer && typeof drawer.getSectionsToRender === 'function' && typeof drawer.renderContents === 'function';
    if (useDrawer) {
      body.sections = drawer.getSectionsToRender().map(s => s.section || s.id);
      body.sections_url = window.location.pathname;
    }
    const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Nie udało się dodać do koszyka');
    if (opts.buyNow) { window.location.href = '/checkout'; return; }
    if (useDrawer && data.sections) {
      try {
        drawer.classList.remove('is-empty');
        const first = (data.items && data.items[0]) || {};
        drawer.renderContents(Object.assign({}, first, { sections: data.sections }));
        return;
      } catch (e) { console.warn(e); }
    }
    window.location.href = '/cart';
  }
};
